<template>
  <BittsCallout
    :title="content.title"
    :subtitle="content.subtitle"
    :type="content.type"
    size="x-small"
    action-text="Contact us"
    @bitts-callout-action="emit('contact-us')"
  />
</template>

<script setup lang="ts">
import { BittsCallout } from '@crossbeam/bitts';

export type UsageLimitCalloutContent = {
  title: string;
  subtitle: string;
  type: 'warning' | 'danger';
};

defineProps<{
  content: UsageLimitCalloutContent;
}>();

const emit = defineEmits(['contact-us']);
</script>
